import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddLandOrderRequest } from '../models/request/landOrder/AddLandOrderRequest';
import { GetLandOrderListPagingAndFilterRequest } from '../models/request/landOrder/GetLandOrderListPagingAndFilterRequest';

export class LandOrderService {
    static async exportLandOrderList(inputObj: GetLandOrderListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportLandOrderList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/LandOrder/exportLandOrderList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getLandOrderListPagingAndFilter(inputObj: GetLandOrderListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetLandOrderListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/LandOrder/GetLandOrderListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addLandOrder(inputObj: AddLandOrderRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddLandOrder', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/LandOrder/AddLandOrder', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }


    static async deleteLandOrder(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteLandOrder', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/LandOrder/deleteLandOrder', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getLandOrderById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getLandOrderById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/LandOrder/getLandOrderById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }
}